import { ROUTER_API } from 'app/constants/api.constant';
import BaseApi from '../api/base.api';
import { HerePosition } from '../hereServices/types';
import { GeoNearCitiesOutDTO } from './types';

export const serviceV2 = new BaseApi({ baseURL: `${ROUTER_API}/services/v2`, tokenKey: 'token' });

export const getNearCities = async (position: HerePosition, distance: number): Promise<GeoNearCitiesOutDTO> => {
  return serviceV2.api
    .get('/geocode/near-cities', {
      params: {
        lat: position.lat,
        lng: position.lng,
        distance,
      },
    })
    .then(response => response.data);
};
